export const SYSTEM_ENVIRONMENTS = Object.freeze({
  "Andrew Test System": "andrew",
  "Dev Test System": "dev",
  "Staging Test System": "staging",
  "Local Test System": "local",
  "Demonstration System": "demonstration",
});

export const SYSTEM_ENVIRONMENT_PURPOSE_MAX_LENGTH = 36;

export const SYSTEM_ENVIRONMENT_HOSTS = Object.freeze({
  "andrew.version4.com": "Andrew Test System",
  "dev.version4.com": "Dev Test System",
  "staging.version4.com": "Staging Test System",
  "version4demo.thedmseffect.com.au": "Demonstration System",
  localhost: "Local Test System",
  "127.0.0.1": "Local Test System",
  "::1": "Local Test System",
  "[::1]": "Local Test System",
});

export const getSystemNameForHostname = (hostname) => {
  const normalisedHostname = typeof hostname === "string"
    ? hostname.trim().toLowerCase().replace(/\.$/, "")
    : "";

  return Object.prototype.hasOwnProperty.call(SYSTEM_ENVIRONMENT_HOSTS, normalisedHostname)
    ? SYSTEM_ENVIRONMENT_HOSTS[normalisedHostname]
    : null;
};
